import $ from 'jquery';

export const elements = {
    input: 'input[name="share-link"]'
};

export default {
    init(params) {
        const { $window, $document } = params;
        $document.on('click', elements.input, (e) => {
            $(e.target).select();
        })
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/share.js